import { Dashboard } from "./Dashboard"

export function App() {
  return <Dashboard />
}
